// Authentication utilities for GOMTB registration app

export interface CurrentUser {
  id: string;
  email: string;
  name: string;
}

// Check if user is logged in
export const isLoggedIn = (): boolean => {
  const userId = localStorage.getItem('gomtb_current_user_id');
  const userEmail = localStorage.getItem('gomtb_current_user_email');
  return !!(userId && userEmail);
};

// Get current logged in user
export const getCurrentUser = (): CurrentUser | null => {
  const id = localStorage.getItem('gomtb_current_user_id');
  const email = localStorage.getItem('gomtb_current_user_email');
  const name = localStorage.getItem('gomtb_current_user_name');
  
  if (id && email && name) {
    return { id, email, name };
  }
  
  return null;
};

// Login user (store session)
export const loginUser = (user: CurrentUser): void => {
  localStorage.setItem('gomtb_current_user_id', user.id);
  localStorage.setItem('gomtb_current_user_email', user.email);
  localStorage.setItem('gomtb_current_user_name', user.name);
  
  // Also store full user object for authService compatibility
  localStorage.setItem('gomtb_user', JSON.stringify(user));
};

// Logout user (clear session)
export const logoutUser = (): void => {
  localStorage.removeItem('gomtb_current_user_id');
  localStorage.removeItem('gomtb_current_user_email');
  localStorage.removeItem('gomtb_current_user_name');
  localStorage.removeItem('gomtb_user'); // Clear full user object
  
  // Also clear any other user-related data
  const keys = Object.keys(localStorage);
  keys.forEach(key => {
    if (key.startsWith('gomtb_user_') || key.startsWith('gomtb_password_')) {
      // Keep passwords for login functionality
      if (!key.startsWith('gomtb_password_')) {
        localStorage.removeItem(key);
      }
    }
  });
};

// Redirect to login if not authenticated
export const requireAuth = (): boolean => {
  if (!isLoggedIn()) {
    window.location.href = '/login';
    return false;
  }
  return true;
}; 